{
  "version": 1,
  "asset_id": "f234e01a-e432-42ac-bb05-7b95b70c6d9f",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/f234e01a-e432-42ac-bb05-7b95b70c6d9f/scar-tissue-crura-esophagus-en-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/f234e01a-e432-42ac-bb05-7b95b70c6d9f/scar-tissue-crura-esophagus-en-1200.webp",
  "original_filename": "scar-tissue-crura-esophagus-en-1200.webp",
  "size": 140844,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:56:05Z"
}
